export const allProducts = [
  {
    id: 1,
    name: "Apple iPhone 15 Pro Max 256GB 钛金属",
    price: 9999,
    originalPrice: 11999,
    image: "https://public.readdy.ai/ai/img_res/084ae8a0be2a2dc5c4135433711f1270.jpg",
    images: [
      "https://readdy.ai/api/search-image?query=Apple%20iPhone%2015%20Pro%20Max%20titanium%20front%20view%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d1a&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Apple%20iPhone%2015%20Pro%20Max%20titanium%20back%20camera%20view%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d1b&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Apple%20iPhone%2015%20Pro%20Max%20titanium%20side%20view%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d1c&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Apple%20iPhone%2015%20Pro%20Max%20titanium%20in%20hand%20lifestyle%20photo%2C%20professional%20photography&width=600&height=600&seq=d1d&orientation=squarish",
    ],
    category: "手机数码",
    sales: 12580,
    rating: 4.9,
    reviewCount: 8821,
    tag: "爆款",
    brand: "Apple",
    specs: {
      colors: ["钛金属黑", "钛金属白", "钛金属蓝", "钛金属原色"],
      storages: ["256GB", "512GB", "1TB"],
    },
    description: "Apple iPhone 15 Pro Max 搭载 A17 Pro 芯片，钛金属机身，支持 USB 3 高速传输，专业级摄影系统，超长续航，是目前最强大的 iPhone。",
    highlights: ["A17 Pro 芯片", "钛金属机身", "4800万像素主摄", "USB 3 接口", "Action 按钮"],
    stock: 128,
  },
  {
    id: 2,
    name: "华为 Mate 60 Pro 旗舰手机 512GB",
    price: 6999,
    originalPrice: 7999,
    image: "https://readdy.ai/api/search-image?query=Huawei%20Mate%2060%20Pro%20flagship%20smartphone%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting&width=400&height=400&seq=prod2&orientation=squarish",
    images: [
      "https://readdy.ai/api/search-image?query=Huawei%20Mate%2060%20Pro%20front%20view%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d2a&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Huawei%20Mate%2060%20Pro%20back%20view%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d2b&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Huawei%20Mate%2060%20Pro%20side%20view%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d2c&orientation=squarish",
    ],
    category: "手机数码",
    sales: 9870,
    rating: 4.8,
    reviewCount: 6540,
    tag: "新品",
    brand: "华为",
    specs: {
      colors: ["雅川青", "白沙银", "砚黑"],
      storages: ["256GB", "512GB", "1TB"],
    },
    description: "华为 Mate 60 Pro 搭载麒麟 9000S 芯片，支持卫星通话，超强信号，专业影像系统，是华为旗舰系列的巅峰之作。",
    highlights: ["麒麟 9000S 芯片", "卫星通话", "超强信号", "可变光圈", "超长续航"],
    stock: 56,
  },
  {
    id: 3,
    name: "戴森 V15 Detect 无线吸尘器",
    price: 4490,
    originalPrice: 5290,
    image: "https://readdy.ai/api/search-image?query=Dyson%20V15%20Detect%20cordless%20vacuum%20cleaner%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting&width=400&height=400&seq=prod3&orientation=squarish",
    images: [
      "https://readdy.ai/api/search-image?query=Dyson%20V15%20Detect%20vacuum%20cleaner%20full%20view%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d3a&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Dyson%20V15%20Detect%20vacuum%20cleaner%20head%20attachment%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d3b&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Dyson%20V15%20Detect%20vacuum%20cleaner%20in%20use%20lifestyle%20photo&width=600&height=600&seq=d3c&orientation=squarish",
    ],
    category: "家用电器",
    sales: 5430,
    rating: 4.7,
    reviewCount: 3210,
    tag: "热销",
    brand: "戴森",
    specs: {
      colors: ["黄色", "镍色"],
      storages: ["标准版", "豪华版"],
    },
    description: "戴森 V15 Detect 配备激光探测技术，可视化显示灰尘颗粒，智能调节吸力，60分钟超长续航，彻底清洁每一个角落。",
    highlights: ["激光探测灰尘", "LCD 实时显示", "60分钟续航", "HEPA 过滤", "智能吸力调节"],
    stock: 89,
  },
  {
    id: 4,
    name: "SK-II 神仙水精华液 230ml 礼盒装",
    price: 1580,
    originalPrice: 1980,
    image: "https://readdy.ai/api/search-image?query=SK-II%20Facial%20Treatment%20Essence%20luxury%20skincare%20bottle%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting&width=400&height=400&seq=prod4&orientation=squarish",
    images: [
      "https://readdy.ai/api/search-image?query=SK-II%20Facial%20Treatment%20Essence%20bottle%20front%20view%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d4a&orientation=squarish",
      "https://readdy.ai/api/search-image?query=SK-II%20skincare%20gift%20box%20set%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d4b&orientation=squarish",
      "https://readdy.ai/api/search-image?query=SK-II%20skincare%20product%20lifestyle%20beauty%20photo&width=600&height=600&seq=d4c&orientation=squarish",
    ],
    category: "美妆护肤",
    sales: 23100,
    rating: 4.9,
    reviewCount: 15600,
    tag: "礼盒",
    brand: "SK-II",
    specs: {
      colors: ["标准礼盒", "限定礼盒"],
      storages: ["230ml", "330ml"],
    },
    description: "SK-II 神仙水含有 90% 以上的 Pitera™ 精华成分，深层滋养肌肤，改善肤质，让肌肤焕发年轻光彩。",
    highlights: ["90%+ Pitera™", "改善肤质", "深层滋养", "礼盒包装", "正品保障"],
    stock: 200,
  },
  {
    id: 5,
    name: "耐克 Air Jordan 1 Retro High OG",
    price: 1299,
    originalPrice: 1599,
    image: "https://readdy.ai/api/search-image?query=Nike%20Air%20Jordan%201%20Retro%20High%20OG%20sneakers%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting&width=400&height=400&seq=prod5&orientation=squarish",
    images: [
      "https://readdy.ai/api/search-image?query=Nike%20Air%20Jordan%201%20Retro%20High%20OG%20sneakers%20side%20view%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d5a&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Nike%20Air%20Jordan%201%20Retro%20High%20OG%20sneakers%20top%20view%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d5b&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Nike%20Air%20Jordan%201%20Retro%20High%20OG%20sneakers%20lifestyle%20photo%20on%20feet&width=600&height=600&seq=d5c&orientation=squarish",
    ],
    category: "运动户外",
    sales: 8760,
    rating: 4.8,
    reviewCount: 5430,
    tag: "限量",
    brand: "Nike",
    specs: {
      colors: ["黑红", "芝加哥", "皇家蓝", "黑白"],
      storages: ["38", "39", "40", "41", "42", "43", "44", "45"],
    },
    description: "Air Jordan 1 Retro High OG 是篮球鞋历史上最具标志性的设计，经典配色，全掌 Air 气垫，皮革鞋面，舒适耐穿。",
    highlights: ["经典 OG 配色", "全掌 Air 气垫", "皮革鞋面", "限量发售", "正品保障"],
    stock: 34,
  },
  {
    id: 6,
    name: "小米 14 Ultra 徕卡影像旗舰",
    price: 5999,
    originalPrice: 6999,
    image: "https://readdy.ai/api/search-image?query=Xiaomi%2014%20Ultra%20Leica%20camera%20smartphone%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting&width=400&height=400&seq=prod6&orientation=squarish",
    images: [
      "https://readdy.ai/api/search-image?query=Xiaomi%2014%20Ultra%20front%20view%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d6a&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Xiaomi%2014%20Ultra%20back%20camera%20view%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d6b&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Xiaomi%2014%20Ultra%20lifestyle%20photo%20in%20hand&width=600&height=600&seq=d6c&orientation=squarish",
    ],
    category: "手机数码",
    sales: 7650,
    rating: 4.8,
    reviewCount: 4890,
    tag: "新品",
    brand: "小米",
    specs: {
      colors: ["白色", "黑色", "钛金"],
      storages: ["256GB", "512GB", "1TB"],
    },
    description: "小米 14 Ultra 与徕卡深度合作，搭载 1 英寸超大底传感器，骁龙 8 Gen 3 芯片，90W 超级快充，专业影像旗舰。",
    highlights: ["徕卡影像系统", "1英寸大底", "骁龙 8 Gen 3", "90W 快充", "IP68 防水"],
    stock: 67,
  },
  {
    id: 7,
    name: "松下 LUMIX S5II 全画幅微单相机",
    price: 12800,
    originalPrice: 14800,
    image: "https://readdy.ai/api/search-image?query=Panasonic%20Lumix%20S5II%20full%20frame%20mirrorless%20camera%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting&width=400&height=400&seq=prod7&orientation=squarish",
    images: [
      "https://readdy.ai/api/search-image?query=Panasonic%20Lumix%20S5II%20camera%20front%20view%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d7a&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Panasonic%20Lumix%20S5II%20camera%20back%20view%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d7b&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Panasonic%20Lumix%20S5II%20camera%20with%20lens%20lifestyle%20photo&width=600&height=600&seq=d7c&orientation=squarish",
    ],
    category: "摄影摄像",
    sales: 3210,
    rating: 4.9,
    reviewCount: 2100,
    tag: "专业",
    brand: "松下",
    specs: {
      colors: ["黑色"],
      storages: ["单机身", "套机 20-60mm", "套机 28-200mm"],
    },
    description: "松下 LUMIX S5II 搭载全画幅传感器，相位对焦系统，6K 视频录制，双原生 ISO，专业视频创作者的理想选择。",
    highlights: ["全画幅传感器", "相位对焦", "6K 视频", "双原生 ISO", "防抖系统"],
    stock: 22,
  },
  {
    id: 8,
    name: "爱马仕 Birkin 30 经典手提包",
    price: 89000,
    originalPrice: 95000,
    image: "https://readdy.ai/api/search-image?query=Hermes%20Birkin%2030%20luxury%20handbag%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic%2C%20high%20detail%2C%20minimalist%20studio%20lighting&width=400&height=400&seq=prod8&orientation=squarish",
    images: [
      "https://readdy.ai/api/search-image?query=Hermes%20Birkin%2030%20luxury%20handbag%20front%20view%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d8a&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Hermes%20Birkin%2030%20luxury%20handbag%20side%20view%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d8b&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Hermes%20Birkin%2030%20luxury%20handbag%20detail%20hardware%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d8c&orientation=squarish",
    ],
    category: "奢侈品",
    sales: 890,
    rating: 5.0,
    reviewCount: 456,
    tag: "奢品",
    brand: "爱马仕",
    specs: {
      colors: ["经典橙", "黑色", "金棕色", "玫瑰粉"],
      storages: ["25cm", "30cm", "35cm"],
    },
    description: "爱马仕 Birkin 是世界上最具标志性的奢侈手袋，采用顶级皮革手工制作，每一个细节都体现了法国工匠精神的极致追求。",
    highlights: ["顶级皮革", "手工制作", "金属配件", "正品保障", "附带证书"],
    stock: 5,
  },
  {
    id: 9,
    name: "索尼 WH-1000XM5 降噪耳机",
    price: 2499,
    originalPrice: 2999,
    image: "https://readdy.ai/api/search-image?query=Sony%20WH-1000XM5%20wireless%20noise%20canceling%20headphones%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic&width=400&height=400&seq=prod9&orientation=squarish",
    images: [
      "https://readdy.ai/api/search-image?query=Sony%20WH-1000XM5%20headphones%20front%20view%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d9a&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Sony%20WH-1000XM5%20headphones%20folded%20view%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d9b&orientation=squarish",
    ],
    category: "手机数码",
    sales: 11200,
    rating: 4.8,
    reviewCount: 7800,
    tag: "热销",
    brand: "索尼",
    specs: {
      colors: ["黑色", "银白色"],
      storages: ["标准版"],
    },
    description: "索尼 WH-1000XM5 搭载行业领先的降噪技术，30小时超长续航，LDAC 高解析音频，多点连接，是旗舰降噪耳机的标杆。",
    highlights: ["行业领先降噪", "30小时续航", "LDAC 高解析", "多点连接", "快速充电"],
    stock: 145,
  },
  {
    id: 10,
    name: "兰蔻小黑瓶精华肌底液 50ml",
    price: 980,
    originalPrice: 1200,
    image: "https://readdy.ai/api/search-image?query=Lancome%20Advanced%20Genifique%20serum%20black%20bottle%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic&width=400&height=400&seq=prod10&orientation=squarish",
    images: [
      "https://readdy.ai/api/search-image?query=Lancome%20Advanced%20Genifique%20serum%20bottle%20front%20view%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d10a&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Lancome%20skincare%20product%20lifestyle%20beauty%20photo&width=600&height=600&seq=d10b&orientation=squarish",
    ],
    category: "美妆护肤",
    sales: 18900,
    rating: 4.7,
    reviewCount: 12300,
    tag: "热销",
    brand: "兰蔻",
    specs: {
      colors: ["标准版", "限定版"],
      storages: ["30ml", "50ml", "100ml"],
    },
    description: "兰蔻小黑瓶精华含有 10 种益生元，深层修护肌肤屏障，提亮肤色，改善细纹，让肌肤焕发年轻活力。",
    highlights: ["10种益生元", "修护屏障", "提亮肤色", "改善细纹", "适合所有肤质"],
    stock: 320,
  },
  {
    id: 11,
    name: "DJI Mini 4 Pro 无人机 标准版",
    price: 4799,
    originalPrice: 5299,
    image: "https://readdy.ai/api/search-image?query=DJI%20Mini%204%20Pro%20drone%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic&width=400&height=400&seq=prod11&orientation=squarish",
    images: [
      "https://readdy.ai/api/search-image?query=DJI%20Mini%204%20Pro%20drone%20top%20view%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d11a&orientation=squarish",
      "https://readdy.ai/api/search-image?query=DJI%20Mini%204%20Pro%20drone%20flying%20outdoor%20lifestyle%20photo&width=600&height=600&seq=d11b&orientation=squarish",
    ],
    category: "手机数码",
    sales: 4320,
    rating: 4.9,
    reviewCount: 2890,
    tag: "新品",
    brand: "大疆",
    specs: {
      colors: ["标准版", "畅飞套装", "畅飞套装 Plus"],
      storages: ["标准版"],
    },
    description: "DJI Mini 4 Pro 重量不足 249g，4K/60fps 视频，全向避障，34分钟续航，是专业级航拍的最佳入门选择。",
    highlights: ["249g 超轻", "4K/60fps", "全向避障", "34分钟续航", "竖拍模式"],
    stock: 78,
  },
  {
    id: 12,
    name: "阿迪达斯 Ultraboost 23 跑鞋",
    price: 1099,
    originalPrice: 1399,
    image: "https://readdy.ai/api/search-image?query=Adidas%20Ultraboost%2023%20running%20shoes%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20ultra%20realistic&width=400&height=400&seq=prod12&orientation=squarish",
    images: [
      "https://readdy.ai/api/search-image?query=Adidas%20Ultraboost%2023%20running%20shoes%20side%20view%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d12a&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Adidas%20Ultraboost%2023%20running%20shoes%20sole%20view%20on%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=d12b&orientation=squarish",
    ],
    category: "运动户外",
    sales: 15600,
    rating: 4.7,
    reviewCount: 9800,
    tag: "热销",
    brand: "阿迪达斯",
    specs: {
      colors: ["白色", "黑色", "蓝色", "红色"],
      storages: ["38", "39", "40", "41", "42", "43", "44", "45"],
    },
    description: "阿迪达斯 Ultraboost 23 搭载 BOOST 中底技术，提供卓越的能量回弹，Primeknit+ 鞋面贴合脚型，是长跑爱好者的首选。",
    highlights: ["BOOST 中底", "能量回弹", "Primeknit+ 鞋面", "Continental 大底", "适合长跑"],
    stock: 234,
  },
];
